import { userService } from "/app/src/services";
import { Action } from "./types";
import { getUserFromStorage } from "./helpers";

/**
 * Login the user and update the user context with the response from the API
 */
export function loginUser(
  dispatch: React.Dispatch<Action>,
  username: string,
  password: string,
  setSubmitting: (isSubmitting: boolean) => void,
) {
  dispatch({ type: "REQUEST_LOGIN" });
  return userService
    .login({ username, password })
    .then((response) => {
      setSubmitting(false);
      localStorage.setItem(
        "currentUser",
        JSON.stringify({
          id: response.id,
          username: response.username,
          refreshToken: response.refreshToken,
          roleId: response.roleId,
          timeZone: response.timeZone,
          viewId: response.viewId,
          accessToken: response.accessToken,
          isAdmin: response.isAdmin,
        }),
      );
      dispatch({ type: "LOGIN_SUCCESS", payload: response });
      return response;
    })
    .catch((error) => {
      setSubmitting(false);
      dispatch({ type: "LOGIN_ERROR", error: error.errors[0] });
      return error;
    });
}

/**
 * Update the user context with the response from the API
 */
export function updateUserContext(
  dispatch: React.Dispatch<Action>,
  response: any,
) {
  dispatch({ type: "UPDATE_USER", payload: response });
  const user = getUserFromStorage();
  localStorage.setItem(
    "currentUser",
    JSON.stringify({
      ...user,
      id: response.id,
      username: response.username,
      roleId: response.roleId,
      timeZone: response.timeZone,
      viewId: response.viewId,
      isAdmin: response.isAdmin,
    }),
  );
}

/**
 * Refresh the user and update the user context with the response from the API
 */
export function refreshUser(
  dispatch: React.Dispatch<Action>,
  refreshToken: string,
) {
  dispatch({ type: "REQUEST_REFRESH" });
  userService
    .refresh(refreshToken)
    .then((response) => {
      const user = getUserFromStorage();
      localStorage.setItem(
        "currentUser",
        JSON.stringify({
          ...user,
          accessToken: response.accessToken,
        }),
      );
      dispatch({ type: "REFRESH_SUCCESS", payload: response });
      return response;
    })
    .catch((error) => {
      return error.message;
    });
}

/**
 * Logout the user and clear the user context. Remove the user from local storage
 */
export function logout(dispatch: React.Dispatch<Action>) {
  dispatch({ type: "LOGOUT" });
  localStorage.removeItem("currentUser");
}
